import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_PRODUCTION_PLAN } from "./graphql";
import PlanForm from "./PlanForm";
import { findComputeErrors } from "./utils";

const PlanDetail = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_PRODUCTION_PLAN, {
    variables: { id },
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const computeErrors = findComputeErrors(data.productionPlan.data);

  console.log("computeErrors", computeErrors);

  return (
    <PlanForm
      originalPlan={data.productionPlan}
      computeErrors={computeErrors}
      disabled={data.productionPlan.state !== "DRAFT"}
    />
  );
};

export default PlanDetail;
